
<v-menu
  v-model="open"
  offset-y
  left
  :close-on-content-click="false"
  min-width="380"
  max-width="380"
>
  <template v-slot:activator="{ on: onMenu }">
    <v-tooltip bottom>
      <template v-slot:activator="{ on: onTooltip }">
        <button
          v-on="{ ...onMenu, ...onTooltip }"
          type="button"
          class="notification-dropdown-activator default-icon-btn"
          :class="{ active: open }"
          data-testid="notification-dropdown-button"
          aria-label="알림"
        >
          <img src="/assets/menu_icon/notification_off.svg" alt="" width="20" height="20">
          <span
            v-if="notificationState.totalUnread > 0"
            class="notification-navbar-badge"
            data-testid="notification-unread-badge"
          >{{ countText(notificationState.totalUnread) }}</span>
        </button>
      </template>
      <span>알림</span>
    </v-tooltip>
  </template>

  <v-card class="notification-dropdown-card" data-testid="notification-dropdown">
    <header class="notification-dropdown-header">
      <div>
        <strong>새 알림</strong>
        <span>읽지 않은 알림 {{ notificationState.totalUnread }}건</span>
      </div>
      <v-progress-circular v-if="notificationState.loading" indeterminate color="#687EFF" :size="20" :width="2" />
    </header>

    <div v-if="partialFailure" class="notification-dropdown-warning">일부 알림을 불러오지 못했습니다.</div>
    <div v-if="!notificationState.loading && notificationState.previewItems.length === 0" class="notification-dropdown-empty">
      읽지 않은 알림이 없습니다.
    </div>
    <button
      v-for="item in notificationState.previewItems"
      :key="item.key"
      type="button"
      class="notification-preview-item"
      data-testid="notification-preview-item"
      :disabled="readingKey === item.key"
      @click="openNotification(item)"
    >
      <span class="notification-preview-dot"></span>
      <span class="notification-preview-content">
        <span><strong>{{ item.title }}</strong><small>{{ sourceLabel(item.source) }}</small></span>
        <span>{{ item.message || '-' }}</span>
        <time>{{ formatDate(item.createdAt) }}</time>
      </span>
    </button>

    <button type="button" class="notification-dropdown-footer" @click="goAllNotifications">
      모든 알림 보기
      <v-icon size="18">mdi-chevron-right</v-icon>
    </button>
  </v-card>
</v-menu>
